import {
  FetchLicenseGenerationSettingsRequest,
  FetchLicenseGenerationSettingsSuccess,
  FetchLicenseGenerationSettingsFailure,
  UpdateLicenseGenerationSettingsRequest,
  UpdateLicenseGenerationSettingsSuccess,
  UpdateLicenseGenerationSettingsFailure,
} from './license-generation-settings.actions'
import { LicenseGenerationSettingsService } from './license-generation-settings.service'
import { ShowSnackbar } from '../../shared/shared.actions'
import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import * as LicenseGenerationSettingsTypes from './license-generation-settings.types'
import { map, switchMap, tap, catchError } from 'rxjs/operators'
import { Router } from '@angular/router'

@Injectable()
export class LicenseGenerationSettingsEffects {
  constructor(
    private actions: Actions,
    private licenseGenerationSettingsService: LicenseGenerationSettingsService,
  ) {}

  FetchLicenseGenerationSettings$ = createEffect(() =>
    this.actions.pipe(
      ofType(
        LicenseGenerationSettingsTypes.FETCH_LICENSE_GENERATION_SETTINGS_REQUEST,
      ),
      switchMap((action: FetchLicenseGenerationSettingsRequest) => {
        return this.licenseGenerationSettingsService
          .fetchLicenseGenerationSettings()
          .pipe(
            map((result) => {
              return new FetchLicenseGenerationSettingsSuccess(result.data)
            }),
            catchError((err, caught) => {
              return of(
                new FetchLicenseGenerationSettingsFailure({ error: err }),
              )
            }),
          )
      }),
    ),
  )

  UpdateLicenseGenerationSettings$ = createEffect(() =>
    this.actions.pipe(
      ofType(
        LicenseGenerationSettingsTypes.UPDATE_LICENSE_GENERATION_SETTINGS_REQUEST,
      ),
      switchMap((action: UpdateLicenseGenerationSettingsRequest) => {
        return this.licenseGenerationSettingsService
          .updateLicenseGenerationSettings(action.payload)
          .pipe(
            switchMap((result) => {
              return [new UpdateLicenseGenerationSettingsSuccess()]
            }),
            catchError((err, caught) => {
              return of(
                new UpdateLicenseGenerationSettingsFailure({ error: err }),
              )
            }),
          )
      }),
    ),
  )
}
